import createConverter from './lib/create_converter';
import AgentAssistanceConfig from 'models/agent_assistance_config';

export default createConverter(AgentAssistanceConfig);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/agent_assistance_config_converter.js